<template>
    <div class="activity-indicator-circle-orbit">
        <div class="activity-indicator-circle-orbit-dot" />
        <div class="activity-indicator-circle-orbit-dot" />
    </div>
</template>